import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import fetchConstants from './actions';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import { hasAccessToRestrictedArticles } from "Services/me";

@injectIntl
@connect((store, props) => ({
  constants: store.constantsFM[props.entity][props.constantName || props.input.name],
}))
export default class SelectConstant extends Component {
  componentDidMount() {
    const { dispatch, entity, input, constantName } = this.props;
    const constantKey = constantName || input.name;

    dispatch(fetchConstants(entity, constantKey));
  }

  render() {
    const {
      input: { name, value, onChange },
      meta = {},
      intl: { formatMessage: f, messages: m },
      labelKey,
      constants,
      className,
      nullable,
      allable,
      disabled,
      required,
      entity,
      constantName,
    } = this.props;

    const { touched, error } = meta;

    const label = labelKey ? f({ id: labelKey }) : f({ id: `field_${name}` });
    const isSelectReady = Boolean(constants && constants.list);

    // Restrict filtering of articles/briefs of status restricted to trusted users
    const contentEntities = ['article', 'brief'];
    const constantKey = constantName || name;
    let constantsFiltered = [];
    if (isSelectReady) {
      if (contentEntities.includes(entity) && constantKey === 'status' && !hasAccessToRestrictedArticles()) {
        constantsFiltered = Object.entries(constants.list).filter($array => !$array.includes('restricted'));
      } else {
        constantsFiltered = Object.entries(constants.list);
      }
    }

    return (
      <FormControl
        fullWidth
        error={Boolean(touched && error)}
        className={className}
        disabled={disabled}
      >
        <InputLabel htmlFor={`select_${label}`}>{label}</InputLabel>
        {isSelectReady ? (
          <Select
            name={name}
            value={value}
            onChange={event => onChange(event.target.value)}
            input={<Input id={`select_${label}`} required={required} />}
            MenuProps={{ PaperProps: { style: { maxHeight: 500 } } }}
          >
            {nullable && (
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
            )}
            {allable && (
              <MenuItem value="all">
                <em>{m.common_all}</em>
              </MenuItem>
            )}
            {constantsFiltered.map(([key, value]) => (
              <MenuItem value={key}>{value}</MenuItem>
            ))}
          </Select>
        ) : null}
        {touched && error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    );
  }
}
